module.exports = __webpack_public_path__ + "media/images/flags/32/Tokelau-3841557adfb7c152eb2d296ab909b4c6.png";